import React, { useMemo } from 'react';
import { Icon, IconButton, List, ListItem, ListItemButton, ListItemText, Popover } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useDispatch } from 'react-redux';

import { settingsActions } from '../../settings/store/settingsSlice';
import { Languages } from '../enums/languages';

const LanguageSelector: React.FC = () => {
  const dispatch = useDispatch();

  const huIconSrc = useMemo(() => '../hu-flag.svg', []);
  const enIconSrc = useMemo(() => '../en-flag.svg', []);

  const [languagePopoverAnchorEl, setLanguagePopoverAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleLanguageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLanguagePopoverAnchorEl(event.currentTarget);
  };

  const handleLanguageChangeClick = (language: Languages) => () => {
    dispatch(settingsActions.setLanguageTo({ language }));
  };

  const handleLanguageSelectPopoverClose = () => {
    setLanguagePopoverAnchorEl(null);
  };

  return (
    <>
      <IconButton aria-describedby="language-select" color="inherit" onClick={handleLanguageButtonClick}>
        <LanguageIcon />
      </IconButton>
      <Popover
        id="language-select"
        open={Boolean(languagePopoverAnchorEl)}
        anchorEl={languagePopoverAnchorEl}
        onClose={handleLanguageSelectPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={handleLanguageChangeClick(Languages.HU)}>
              <ListItemText sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Icon sx={{ marginRight: '8px' }}>
                  <img alt="hu-icon" src="../hu-flag.svg" />
                </Icon>
                HU
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleLanguageChangeClick(Languages.EN)}>
              <ListItemText sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Icon sx={{ marginRight: '8px' }}>
                  <img alt="hu-icon" src="../en-flag.svg" />
                </Icon>
                EN
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

export default LanguageSelector;
